import React from 'react';
import { IconButton, Typography, Box, useTheme, useMediaQuery } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

interface BackButtonWithTitleProps {
    title: string;
}

const BackButtonWithTitle: React.FC<BackButtonWithTitleProps> = ({ title }) => {
    const navigate = useNavigate();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    return (
        <Box display="flex" alignItems="center" justifyContent="center" width="100%" >
            <IconButton onClick={() => navigate(-1)} sx={{ position: 'absolute', left: isDesktop ? '252px' : '28px' }} aria-label='back' >
                <ArrowBackIcon sx={{ color: 'white' }} />
            </IconButton>
            <Typography variant="h2" sx={{ textAlign: 'center', flex: 1 }}>
                {title}
            </Typography>
        </Box>
    );
};

export default BackButtonWithTitle;
